import React from 'react';

interface Props {
  iconSize?: number;
  fontSize?: string;
  onDark?: boolean;
}

export default function AreteLogo({ iconSize = 36, fontSize = '1.2rem', onDark = false }: Props) {
  const textColor = onDark ? 'text-white' : 'text-arete-navy';

  const sidebarColor = onDark ? '#F5F0E8' : '#1B3022';
  const accentColor  = onDark ? '#8BB88A' : '#5A8A58';

  return (
    <div className="flex items-center gap-3">
      {/* Icon: stylized "A" / mountain peak + pulse line */}
      <svg width={iconSize} height={iconSize} viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="20" fill={onDark ? '#F5F0E8' : '#1B3022'} opacity="0.1" />
        {/* Mountain peak */}
        <path d="M20 8 L30 28 H10 Z" fill={sidebarColor} opacity={onDark ? 0.7 : 1} />
        <path d="M20 8 L30 28 H10 Z" fill={accentColor} opacity="0.35" />
        {/* Pulse line */}
        <path d="M6 24 L12 24 L14 20 L17 28 L20 16 L23 28 L26 20 L28 24 L34 24"
          stroke={accentColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>

      <div>
        <div className="tracking-tight" style={{ fontSize, lineHeight: 1.1, color: sidebarColor, fontFamily: "'DM Serif Display', Georgia, serif" }}>
          Arete Health
        </div>
        <div style={{ fontSize: '0.6rem', letterSpacing: '0.12em', textTransform: 'uppercase' as const, color: onDark ? 'rgba(245,240,232,0.35)' : 'rgba(27,48,34,0.4)' }}>
          Integrated Health
        </div>
      </div>
    </div>
  );
}
